import gql from 'graphql-tag';

export const updateNewsFeedItemTargetsQuery = gql`
  mutation updateNewsFeedItemTargets($itemId: String!, $targets: [String]!) {
    updateNewsFeedItemTargets(itemId: $itemId, targets: $targets)
  }
`;
